import { render, staticRenderFns } from "./modelCreateList.vue?vue&type=template&id=c13ab618&scoped=true&"
import script from "./modelCreateList.vue?vue&type=script&lang=js&"
export * from "./modelCreateList.vue?vue&type=script&lang=js&"
import style0 from "./modelCreateList.vue?vue&type=style&index=0&id=c13ab618&lang=less&scoped=true&"
import style1 from "./modelCreateList.vue?vue&type=style&index=1&id=c13ab618&scoped=true&lang=css&"
import style2 from "./modelCreateList.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13ab618",
  null
  
)

component.options.__file = "modelCreateList.vue"
export default component.exports